<template>
  <app-data-editor
    :id="id"
    title="Редактирование  Рода деятельности"
    resource="activity-types"
    :elements="elements"
    add-message="Род деятельности добавлен"
    edit-message="Род деятельности изменен"
    @change="(payload) => isChanged = payload"
  />
</template>

<script>
import mixin from "./../../mixins/confirm-cancel-changes.js";
export default {
  mixins: [mixin],
  props: ["id"],
  data() {
    return {
      elements: [
        [
          {
            title: "Наименование",
            name: "title",
            control: {
              type: "title-text",
              required: true,
              rules: [
                v => !!v || "Наименование обязательно к заполнению",
                v =>
                  v.length >= 3 ||
                  "Наименование должно содержать не менее 3-х символов",
              ],
            },
            default: "",
          },
        ],
      ],
    };
  },
};
</script>
